/**
 * Multi-step survey for CPT bewerben (?umfrage=1).
 */

const ICON_THUMBS_UP = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5.00004 17.5V8.33334M0.833374 10V15.8333C0.833374 16.7538 1.57957 17.5 2.50004 17.5H13.6886C14.9225 17.5 15.9719 16.5997 16.1595 15.3801L17.0569 9.54681C17.2899 8.03242 16.1182 6.66667 14.586 6.66667H11.6667C11.2065 6.66667 10.8334 6.29357 10.8334 5.83334V2.8882C10.8334 1.75333 9.91338 0.833336 8.77851 0.833336C8.50782 0.833336 8.26252 0.992748 8.15259 1.2401L5.21999 7.83845C5.08624 8.13939 4.7878 8.33334 4.45848 8.33334H2.50004C1.57957 8.33334 0.833374 9.07953 0.833374 10Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const ICON_THUMBS_DOWN = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12.8818 0.833336V10M17.0484 7.33334V3.5C17.0484 2.56658 17.0484 2.09987 16.8668 1.74335C16.707 1.42975 16.452 1.17478 16.1384 1.01499C15.7819 0.833336 15.3152 0.833336 14.3818 0.833336H5.4801C4.2622 0.833336 3.65325 0.833336 3.16141 1.0562C2.72792 1.25262 2.35951 1.56869 2.09946 1.96727C1.8044 2.4195 1.7118 3.02137 1.52661 4.22511L1.09072 7.05844C0.846461 8.6461 0.724334 9.43992 0.959928 10.0576C1.16671 10.5997 1.55563 11.0531 2.06003 11.3399C2.6347 11.6667 3.43787 11.6667 5.0442 11.6667H5.71509C6.1818 11.6667 6.41516 11.6667 6.59342 11.7575C6.75022 11.8374 6.8777 11.9649 6.9576 12.1217C7.04842 12.2999 7.04842 12.5333 7.04842 13V15.4451C7.04842 16.58 7.96842 17.5 9.10329 17.5C9.37398 17.5 9.61927 17.3406 9.72921 17.0932L12.5298 10.7918C12.6572 10.5052 12.7209 10.3619 12.8216 10.2568C12.9106 10.1639 13.0199 10.0929 13.1409 10.0493C13.2778 10 13.4346 10 13.7483 10H14.3818C15.3152 10 15.7819 10 16.1384 9.81835C16.452 9.65856 16.707 9.40359 16.8668 9.08999C17.0484 8.73347 17.0484 8.26676 17.0484 7.33334Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const initBeworbenSurvey = () => {
	const root = document.querySelector('[data-bewerben-survey]');

	if (!root) {
		return;
	}

	const configEl = root.querySelector('[data-survey-config]');
	let config = { questions: [] };

	try {
		config = JSON.parse(configEl ? configEl.textContent : '{}');
	} catch (e) {
		return;
	}

	const questions = Array.isArray(config.questions) ? config.questions : [];

	const introEl = root.querySelector('[data-survey-intro]');
	const stepsEl = root.querySelector('[data-survey-steps]');
	const questionEl = root.querySelector('[data-survey-question]');
	// Progress-Badge sitzt im Header (außerhalb von [data-bewerben-survey])
	const progressEl = document.querySelector('[data-survey-progress]');
	const backBtn = root.querySelector('[data-survey-back]');
	const nextBtn = root.querySelector('[data-survey-next]');
	const rejectEl = root.querySelector('[data-survey-reject]');
	const rejectBackBtn = root.querySelector('[data-survey-reject-back]');
	const formEl = root.querySelector('[data-survey-form]');
	const iconsEl = root.querySelector('[data-survey-icons]');

	const iconFromDom = (selector, fallback) => {
		const el = iconsEl ? iconsEl.querySelector(selector) : null;
		const html = el ? el.innerHTML.trim() : '';
		return html || fallback;
	};

	const iconThumbsUp = iconFromDom('[data-icon-thumbs-up]', ICON_THUMBS_UP);
	const iconThumbsDown = iconFromDom('[data-icon-thumbs-down]', ICON_THUMBS_DOWN);

	let stepIndex = 0;
	const answers = [];

	const show = (el) => {
		if (el) {
			el.hidden = false;
		}
	};

	const hide = (el) => {
		if (el) {
			el.hidden = true;
		}
	};

	const escapeHtml = (str) =>
		String(str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');

	const writeHiddenAnswers = () => {
		const gfId = formEl ? formEl.getAttribute('data-gf-id') : '0';
		const fieldId = formEl ? formEl.getAttribute('data-gf-hidden-id') : '0';
		const jobTitleFieldId = formEl
			? formEl.getAttribute('data-gf-job-title-id')
			: '0';

		if (!gfId || gfId === '0') {
			return;
		}

		const setHiddenFieldValue = (id, parameterName, value) => {
			if (!id || id === '0' || !formEl) {
				return;
			}

			const input =
				document.querySelector(`#input_${gfId}_${id}`) ||
				formEl.querySelector(`input[name="input_${id}"]`) ||
				formEl.querySelector(`input[name="${parameterName}"]`);

			if (input) {
				input.value = value;
			}
		};

		const formatAnswer = (value) => {
			const answer = Array.isArray(value) ? value.join(', ') : value;
			return escapeHtml(answer || '');
		};

		const surveyResults = answers
			.map((entry, index) => {
				if (!entry || !questions[index]) {
					return '';
				}

				return `<strong>${escapeHtml(
					questions[index].text
				)}</strong><br>${formatAnswer(entry.value)}`;
			})
			.filter(Boolean)
			.join('<br><br>');

		setHiddenFieldValue(fieldId, 'survey_results', surveyResults);
		setHiddenFieldValue(jobTitleFieldId, 'job_title', config.jobTitle || '');
	};

	const scrollToTop = () => {
		window.requestAnimationFrame(() => {
			window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
		});
	};

	const showReject = () => {
		hide(introEl);
		hide(stepsEl);
		hide(formEl);
		hide(progressEl);
		show(rejectEl);
		scrollToTop();
	};

	const showForm = () => {
		hide(introEl);
		hide(stepsEl);
		hide(rejectEl);
		hide(progressEl);
		show(formEl);
		writeHiddenAnswers();
		scrollToTop();
	};

	const isAusschluss = (question, selected) => {
		if (!question || !question.antworten) {
			return false;
		}

		const selectedValues = Array.isArray(selected) ? selected : [selected];

		return question.antworten.some(
			(opt) => opt.ausschluss && selectedValues.indexOf(opt.label) !== -1
		);
	};

	const advanceAfterAnswer = (question, value) => {
		if (isAusschluss(question, value)) {
			showReject();
			return;
		}

		stepIndex += 1;

		if (stepIndex >= questions.length) {
			showForm();
			return;
		}

		renderQuestion();
	};

	const trueFalseIconForIndex = (index, label) => {
		const normalized = String(label || '').toLowerCase().trim();
		if (normalized === 'ja' || normalized === 'yes') {
			return iconThumbsUp;
		}
		if (normalized === 'nein' || normalized === 'no') {
			return iconThumbsDown;
		}
		return index === 0 ? iconThumbsUp : iconThumbsDown;
	};

	const renderTrueFalseOptions = (question, selected) => {
		const options = question.antworten || [];
		return `<div class="bewerben-survey__options bewerben-survey__options--true-false" data-survey-options>
			${options
				.map((opt, index) => {
					const icon = trueFalseIconForIndex(index, opt.label);
					return `
					<button type="button" class="bewerben-survey__option bewerben-survey__option--true-false${
						selected === opt.label ? ' is-selected' : ''
					}" data-value="${escapeHtml(opt.label)}">
						<span class="bewerben-survey__option-icon" aria-hidden="true">${icon}</span>
						<span class="bewerben-survey__option-label">${escapeHtml(opt.label)}</span>
					</button>`;
				})
				.join('')}
		</div>`;
	};

	const renderOneSelectOptions = (question, selected) => {
		return `<div class="bewerben-survey__options bewerben-survey__options--one-select" data-survey-options>
			${(question.antworten || [])
				.map(
					(opt) => `
				<button type="button" class="bewerben-survey__option bewerben-survey__option--one-select${
					selected === opt.label ? ' is-selected' : ''
				}" data-value="${escapeHtml(opt.label)}">
					<span class="bewerben-survey__option-label">${escapeHtml(opt.label)}</span>
				</button>`
				)
				.join('')}
		</div>`;
	};

	const renderMultiSelectOptions = (question, selected) => {
		return `<div class="bewerben-survey__options bewerben-survey__options--multi" data-survey-options data-multi="1">
			${(question.antworten || [])
				.map((opt) => {
					const isSelected = selected.indexOf(opt.label) !== -1;
					const desc = opt.beschreibung
						? `<span class="bewerben-survey__option-desc">${escapeHtml(opt.beschreibung)}</span>`
						: '';
					return `
					<button type="button" class="bewerben-survey__option bewerben-survey__option--multi${
						isSelected ? ' is-selected' : ''
					}" data-value="${escapeHtml(opt.label)}" aria-pressed="${isSelected}">
						<span class="bewerben-survey__radio" aria-hidden="true"></span>
						<span class="bewerben-survey__option-text">
							<span class="bewerben-survey__option-label">${escapeHtml(opt.label)}</span>
							${desc}
						</span>
					</button>`;
				})
				.join('')}
		</div>`;
	};

	const renderTextarea = (existing) => {
		return `
			<div class="bewerben-survey__textarea-wrap">
				<label class="bewerben-survey__textarea-label" for="bewerben-survey-textarea">
					Antwort <span class="bewerben-survey__required">*</span>
				</label>
				<textarea
					id="bewerben-survey-textarea"
					class="bewerben-survey__textarea"
					data-survey-textarea
					rows="5"
					placeholder="Hier schreiben..."
				>${escapeHtml(existing || '')}</textarea>
			</div>
		`;
	};

	const renderQuestion = () => {
		const question = questions[stepIndex];

		if (!question) {
			showForm();
			return;
		}

		// Intro nur bei der ersten Frage
		if (stepIndex === 0) {
			show(introEl);
		} else {
			hide(introEl);
		}

		show(stepsEl);
		show(progressEl);

		if (progressEl) {
			progressEl.textContent = `Frage ${stepIndex + 1} von ${questions.length}`;
		}

		let optionsHtml = '';
		let subtitleHtml = '';

		if (question.type === 'textarea') {
			const existing = answers[stepIndex] ? answers[stepIndex].value : '';
			optionsHtml = renderTextarea(existing);
		} else if (question.type === 'multi_select') {
			subtitleHtml =
				'<p class="bewerben-survey__subtitle">(Mehrfachauswahl möglich)</p>';
			const selected =
				answers[stepIndex] && Array.isArray(answers[stepIndex].value)
					? answers[stepIndex].value
					: [];
			optionsHtml = renderMultiSelectOptions(question, selected);
		} else if (question.type === 'true_false') {
			const selected = answers[stepIndex] ? answers[stepIndex].value : '';
			optionsHtml = renderTrueFalseOptions(question, selected);
		} else {
			const selected = answers[stepIndex] ? answers[stepIndex].value : '';
			optionsHtml = renderOneSelectOptions(question, selected);
		}

		questionEl.innerHTML = `
			<div class="bewerben-survey__frage-wrap">
				<h2 class="bewerben-survey__frage">${escapeHtml(question.text)}</h2>
				${subtitleHtml}
			</div>
			${optionsHtml}
		`;

		root.setAttribute('data-survey-type', question.type);

		// Zurück immer sichtbar (Frage 1 → zurück zur Landingpage)
		if (backBtn) {
			backBtn.hidden = false;
		}

		const needsNext =
			question.type === 'textarea' || question.type === 'multi_select';

		if (needsNext) {
			nextBtn.hidden = false;
			nextBtn.disabled = !canAdvance(question);
		} else {
			nextBtn.hidden = true;
		}

		bindOptionEvents(question);
	};

	const canAdvance = (question) => {
		const current = answers[stepIndex];

		if (!current) {
			return false;
		}

		if (question.type === 'textarea') {
			return String(current.value || '').trim().length > 0;
		}

		if (question.type === 'multi_select') {
			return Array.isArray(current.value) && current.value.length > 0;
		}

		return !!current.value;
	};

	const storeAnswer = (value) => {
		answers[stepIndex] = { value };
	};

	const goNext = () => {
		const question = questions[stepIndex];
		const current = answers[stepIndex];

		if (!question || !current || !canAdvance(question)) {
			return;
		}

		advanceAfterAnswer(question, current.value);
	};

	const goBack = () => {
		if (stepIndex <= 0) {
			// Erste Frage: zurück zur Landingpage (ohne ?umfrage=1)
			window.location.href = config.shareUrl || window.location.pathname;
			return;
		}
		stepIndex -= 1;
		renderQuestion();
	};

	const bindOptionEvents = (question) => {
		const textarea = questionEl.querySelector('[data-survey-textarea]');

		if (textarea) {
			textarea.addEventListener('input', () => {
				storeAnswer(textarea.value);
				nextBtn.disabled = !canAdvance(question);
			});
			return;
		}

		const optionsWrap = questionEl.querySelector('[data-survey-options]');

		if (!optionsWrap) {
			return;
		}

		const isMulti = optionsWrap.getAttribute('data-multi') === '1';

		optionsWrap.querySelectorAll('.bewerben-survey__option').forEach((btn) => {
			btn.addEventListener('click', () => {
				const value = btn.getAttribute('data-value');

				if (isMulti) {
					btn.classList.toggle('is-selected');
					btn.setAttribute(
						'aria-pressed',
						btn.classList.contains('is-selected') ? 'true' : 'false'
					);
					const selected = Array.from(
						optionsWrap.querySelectorAll('.bewerben-survey__option.is-selected')
					).map((el) => el.getAttribute('data-value'));
					storeAnswer(selected);
					nextBtn.disabled = !canAdvance(question);
					return;
				}

				optionsWrap.querySelectorAll('.bewerben-survey__option').forEach((el) => {
					el.classList.remove('is-selected');
				});
				btn.classList.add('is-selected');
				storeAnswer(value);

				// Ja/Nein + One-Select: sofort weiter
				if (question.type === 'one_select' || question.type === 'true_false') {
					window.setTimeout(() => {
						advanceAfterAnswer(question, value);
					}, 120);
				}
			});
		});
	};

	if (backBtn) {
		backBtn.addEventListener('click', goBack);
	}

	if (rejectBackBtn) {
		rejectBackBtn.addEventListener('click', () => {
			hide(rejectEl);
			renderQuestion();
			scrollToTop();
		});
	}

	if (nextBtn) {
		nextBtn.addEventListener('click', goNext);
	}

	if (window.jQuery) {
		window.jQuery(document).on('gform_post_render', writeHiddenAnswers);
	}

	if (!questions.length) {
		showForm();
		return;
	}

	show(stepsEl);
	stepIndex = 0;
	renderQuestion();
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initBeworbenSurvey);
} else {
	initBeworbenSurvey();
}
